var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSec01Img(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 230.636,
    height: 372.201,
    viewBox: "0 0 230.636 372.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1",
    "data-name": "\\u9577\\u65B9\\u5F62 1",
    width: 230.636,
    height: 372.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2",
    "data-name": "\\u9577\\u65B9\\u5F62 2",
    width: 230.636,
    height: 372.201,
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec01img",
    transform: "translate(-1154 -1122.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_204",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sec01img-2",
    "data-name": "sec01img",
    transform: "translate(239 693.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_5",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 5",
    transform: "translate(915 429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_38",
    "data-name": "\\u30D1\\u30B9 38",
    d: "M18.969,281.412l-2.333-23.667,23-56.333,16.333-27.667,34.333-20,4.667-9.333-14.333-6.667-8.667-17-7-43.667L75.3,50.412l91.333,24.667v6.333l3.333,7.667-6.333,13.667-9,12.333H147.3l3.333,18,39,75.667L171.969,319.079l-122-22.333Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1",
    "data-name": "\\u30D1\\u30B9 1",
    d: "M51.644,50.092S63.411,17.056,64.768,16.6,88.3.31,95.995,1.668,122.243-1.5,130.389,6.646s30.774,21.723,31.679,33.49-2.715,37.561-4.073,39.373S141.7,71.363,141.7,71.363l-13.577,2.262S105.5,70,103.687,69.551s-27.153-8.6-29.415-8.146-15.84,1.358-15.84,1.358l-2.263,14.03s-25.8-2.263-25.8-4.526S51.644,50.092,51.644,50.092",
    transform: "translate(10.864 0.567)",
    fill: "#72acd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2",
    "data-name": "\\u30D1\\u30B9 2",
    d: "M104.207,57.052l5.431,14.708L121.63,56.6l-6.335-3.621Z",
    transform: "translate(37.272 18.949)",
    fill: "#5a6468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_3",
    "data-name": "\\u30D1\\u30B9 3",
    d: "M101.78,64.646,97.706,74.829l2.715,8.373,4.752-3.394-1.358-12.219Z",
    transform: "translate(34.947 23.122)",
    fill: "#accfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4",
    "data-name": "\\u30D1\\u30B9 4",
    d: "M220.2,143.687l-16.744-12.219-40.278-14.934-5.431-10.408-6.788-8.146L128.78,117.892l-21.723,9.957-5.883-3.621V110.651H94.839l-9.956,11.313-25.344,5.884-16.292,19.46L22.43,186.227.707,240.988l4.977,27.154,9.957,10.408,11.313-1.81,14.029-3.167-1.81,59.738L202.095,331.5l-2.263-51.592-1.358-9.05,6.336-14.482,12.219-37.109,10.409-36.657.452-22.628ZM47.621,180.346l21.12-.3.6,8.449-15.991,3.921-6.638-7.543ZM31.48,234.2l-11.087-6.336,4.073-5.2-5.431-4.526,1.131-4.752.679-5.2,2.489-1.358,14.934,3.394-10.635-8.825V198l5.2-.679,8.825,3.845s29.19,22.176,28.511,21.949S31.48,234.2,31.48,234.2m97.752,3.394-1.583-4.073-4.073-15.84,1.583-2.489L148.24,217,159.1,236.009Zm39.071-48.5-23.231,4.829-17.5-5.431v-9.656l38.618,1.51,2.113,3.317Z",
    transform: "translate(0.253 35.045)",
    fill: "#72acd3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_4",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5",
    "data-name": "\\u30D1\\u30B9 5",
    d: "M126.677,102.908c-10.591,23.109-35.627,26-45.255,26S61.2,120.24,56.386,109.649,50,72.683,49.04,61.128l3.62-14.482",
    transform: "translate(17.54 16.684)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_6",
    "data-name": "\\u30D1\\u30B9 6",
    d: "M109.279,68.281c4.525-6.336,8.146-14.482,15.387-9.956s7.242,13.577,2.715,20.817-10.861,19.913-19.007,14.482",
    transform: "translate(38.762 20.393)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7",
    "data-name": "\\u30D1\\u30B9 7",
    d: "M152.342,65.449S127,49.157,109.8,41.463,62.284,38.3,50.969,39.653c-12.219,7.694-20.817,17.2-19.912,19.46S55.5,62.282,55.5,62.282",
    transform: "translate(11.085 13.267)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_8",
    "data-name": "\\u30D1\\u30B9 8",
    d: "M36.04,52.768c9.956-1.81,18.1-8.6,37.563-6.336s42.992,13.577,65.62,10.409",
    transform: "translate(12.891 16.444)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    "data-name": "\\u30D1\\u30B9 9",
    d: "M151.6,79.991c4.525-5.431,5.883-28.963,5.883-36.657S136.218,6.224,109.517,2.151,66.523,14.37,61.093,16.632,47.969,46.5,45.706,52.385",
    transform: "translate(16.348 0.537)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M101.706,11.646C108.266,17.112,118,27.033,118,35.179S116.64,56.9,116.64,56.9",
    transform: "translate(36.378 4.165)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_1",
    "data-name": "\\u7DDA 1",
    x2: 6.638,
    y2: 17.65,
    transform: "translate(140.951 74.191)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11",
    "data-name": "\\u30D1\\u30B9 11",
    d: "M70.881,67.313C67.713,70.934,64.093,79.532,65.45,82.7s6.788,4.979,6.788,4.979",
    transform: "translate(23.305 24.076)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M68.307,50.646C67.4,54.267,59.256,61.507,53.373,59.7",
    transform: "translate(19.09 18.115)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13",
    "data-name": "\\u30D1\\u30B9 13",
    d: "M63.707,90.493c4.168-2.866,18.1-3.167,25.342,3.167",
    transform: "translate(22.786 31.669)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M74.04,107.979s0,12.219,1.81,13.125",
    transform: "translate(26.482 38.621)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_2",
    "data-name": "\\u7DDA 2",
    x2: 0.906,
    y2: 11.767,
    transform: "translate(148.493 119.9)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M124.3,96.646A104.455,104.455,0,0,1,79.04,127.872",
    transform: "translate(28.271 34.568)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M71.787,107.979s-7.694,8.6-8.6,11.767-.453,30.321-.453,30.321l14.482-22.628",
    transform: "translate(22.399 38.621)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M78.04,131.9c2.263,1.81,6.336,25.8,6.336,25.8s47.065-41.182,47.519-45.255-4.979-13.125-4.979-13.125",
    transform: "translate(27.913 35.522)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M117.706,108.979c10.409,5.883,48.876,19.007,53.855,24.438",
    transform: "translate(42.1 38.979)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M198.14,130.979c2.263,3.167,12.671,15.387,5.883,40.73S182.3,256.337,172.8,263.579s-25.8,11.313-27.153,10.408-83.27-23.08-83.27-23.08",
    transform: "translate(22.309 46.848)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_3",
    "data-name": "\\u7DDA 3",
    x2: 2.263,
    y2: 60.19,
    transform: "translate(200.085 307.711)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_4",
    "data-name": "\\u7DDA 4",
    x1: 1.358,
    y2: 57.022,
    transform: "translate(40.332 313.142)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M76.035,114.646c-6.336,2.263-21.271,2.263-32.132,12.219s-17.2,23.986-17.2,23.986",
    transform: "translate(9.552 41.006)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21",
    "data-name": "\\u30D1\\u30B9 21",
    d: "M33.459,146.646c-2.715,4.979-35.3,69.241-31.679,82.818s1.81,29.417,17.2,31.679,106.8-37.561,106.8-37.561",
    transform: "translate(0.537 52.451)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_22",
    "data-name": "\\u30D1\\u30B9 22",
    d: "M17.04,207.562c9.052-4.525,74.22-22.175,80.555-22.628s14.482-4.073,17.2-1.358,7.694,13.577,6.788,20.365",
    transform: "translate(6.095 65.302)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_23",
    "data-name": "\\u30D1\\u30B9 23",
    d: "M91.706,183.979c7.694,1.81,20.817-1.358,24.89,3.621s8.6,13.577,8.6,13.577",
    transform: "translate(32.801 65.804)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24",
    "data-name": "\\u30D1\\u30B9 24",
    d: "M159.624,130.979C145.6,135.958,127.04,152.7,127.04,161.753",
    transform: "translate(45.439 46.848)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25",
    "data-name": "\\u30D1\\u30B9 25",
    d: "M141.717,153.646c-5.883,7.694-19.913,31.679-22.175,37.563s-3.169,15.386-3.169,15.386",
    transform: "translate(41.624 54.955)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_26",
    "data-name": "\\u30D1\\u30B9 26",
    d: "M96.04,200.985c3.167,0,31.226-4.073,49.782,2.263",
    transform: "translate(34.351 71.426)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_27",
    "data-name": "\\u30D1\\u30B9 27",
    d: "M42.406,130.313c-2.263,7.694-8.146,35.752-7.694,43.446",
    transform: "translate(12.407 46.61)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28",
    "data-name": "\\u30D1\\u30B9 28",
    d: "M62.449,195.883s-9.052-7.24-13.577-10.409-14.273-13-24.665-14.481c-3.167-.453-4.977,2.262-2.941,5.2s20.365,13.125,21.5,14.708",
    transform: "translate(7.298 61.142)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29",
    "data-name": "\\u30D1\\u30B9 29",
    d: "M27.16,200.948c-5.2-2.489-12.671-4.979-11.767-7.919l4.979-2.715",
    transform: "translate(5.479 68.07)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_30",
    "data-name": "\\u30D1\\u30B9 30",
    d: "M43,187.212c-4.073-2.037-19.913-7.694-21.044-7.919s-4.525-1.358-5.431.452c-.417.835-2.037,4.3-.679,4.3s21.271,9.729,23.08,11.54",
    transform: "translate(5.478 63.929)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_31",
    "data-name": "\\u30D1\\u30B9 31",
    d: "M17.626,183.146c-2.715.227-3.846,3.394-3.394,4.752s6.11,4.3,7.694,4.979,10.936,4.676,10.936,4.676",
    transform: "translate(5.056 65.506)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_32",
    "data-name": "\\u30D1\\u30B9 32",
    d: "M93.929,157.535s37.412,1.207,39.523,1.508,1.207,9.052,1.207,9.052-22.024,5.129-23.231,5.129-17.5-5.733-17.5-5.733Z",
    transform: "translate(33.596 56.346)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_33",
    "data-name": "\\u30D1\\u30B9 33",
    d: "M37.2,158.424H56.508l-.3,9.654-13.878,2.715L36.6,167.173",
    transform: "translate(13.089 56.664)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_5",
    "data-name": "\\u7DDA 5",
    y2: 17.8,
    transform: "translate(68.089 226.251)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_6",
    "data-name": "\\u7DDA 6",
    y2: 21.723,
    transform: "translate(129.335 225.346)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_7",
    "data-name": "\\u7DDA 7",
    y2: 6.638,
    transform: "translate(165.841 225.346)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_8",
    "data-name": "\\u7DDA 8",
    x1: 0.603,
    y2: 10.861,
    transform: "translate(46.065 226.854)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_34",
    "data-name": "\\u30D1\\u30B9 34",
    d: "M76.806,125.535l-.6,21.723-6.94,22.93L65.04,207.6",
    transform: "translate(23.263 44.901)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_9",
    "data-name": "\\u7DDA 9",
    x2: 0.603,
    y2: 69.091,
    transform: "translate(86.493 299.867)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_35",
    "data-name": "\\u30D1\\u30B9 35",
    d: "M88.947,65.156a3.62,3.62,0,1,1-3.621-3.621,3.621,3.621,0,0,1,3.621,3.621",
    transform: "translate(29.224 22.009)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_36",
    "data-name": "\\u30D1\\u30B9 36",
    d: "M65.836,63.378a3.62,3.62,0,1,1-3.621-3.621,3.621,3.621,0,0,1,3.621,3.621",
    transform: "translate(20.958 21.374)",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_37",
    "data-name": "\\u30D1\\u30B9 37",
    d: "M102.68,59.979c-1.473,6.756-5.239,15.444-4.584,19.063s2.292,5.79,3.765,5.309,3.766-2.654,3.11-7.239S103.662,66.976,102.68,59.979Z",
    transform: "translate(35.059 21.453)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec01Img);
export default __webpack_public_path__ + "static/media/sec01img.4ed675e352513057935fc9d6e501ee95.svg";
export { ForwardRef as ReactComponent };